import React from 'react';
import { HelpCircle } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';

/**
 * Small "?" icon that opens a friendly explainer popover on click.
 *
 * Props:
 *   title    — bold heading inside the popover
 *   children — the explanation body (JSX or string). Supports paragraphs and lists.
 *   testId   — optional data-testid on the trigger
 *   align    — 'start' | 'center' | 'end' (default 'start')
 */
export default function InfoTip({ title, children, testId, align = 'start' }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          aria-label={title ? `What is ${title}?` : 'More info'}
          className="inline-flex items-center justify-center w-5 h-5 rounded-full text-[#9A8A7E] hover:text-[#7B2C3B] hover:bg-[#F4E4DA] transition-colors focus:outline-none focus:ring-2 focus:ring-[#7B2C3B]/30"
        >
          <HelpCircle className="w-4 h-4" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        align={align}
        sideOffset={6}
        className="w-72 sm:w-80 p-4 text-sm bg-white border border-[#EFE3D8] rounded-2xl shadow-lg"
      >
        {title && <p className="font-serif text-[15px] text-[#2A2A2A] mb-2 leading-tight">{title}</p>}
        <div className="text-[13px] leading-relaxed text-[#4A4A4A] space-y-2">{children}</div>
      </PopoverContent>
    </Popover>
  );
}
